import { Message } from 'element-ui';

// 绑定设备参数校验
export const validateBindParams = (formData, mainTableAllSelected, mainTableIsIndeterminate) => {
    if (!formData.deviceType || !formData.deviceNo) {
        Message.warning('设备类型或设备号不能为空');
        return false;
    }
    if (!mainTableAllSelected && !mainTableIsIndeterminate) {
        Message.warning('请选择要绑定的TK单');
        return false;
    }
    return true;
};

// 绑定设备参数处理
export const dealWithBindParams = (formData, tableData) => {
    return {
        ...formData,
        taskNoList: dealWithTaskNoList(tableData)
    };
};

// 取消绑定参数校验
export const validateCancelBindParams = (formData, mainTableAllSelected, mainTableIsIndeterminate) => {
    if (!mainTableAllSelected && !mainTableIsIndeterminate) {
        Message.warning('请选择要绑定的TK单');
        return false;
    }
    return true;
};

// 取消绑定参数处理
export const dealWithCancelBindParams = (formData, tableData) => {
    return {
        dispatchNo: formData.dispatchNo,
        taskNoList: dealWithTaskNoList(tableData)
    };
};

const dealWithTaskNoList = tableData => {
    const taskNoList = [];
    const selectedMainRowData = tableData.filter(item => item.expandTableAllSelected || item.expandTableIsIndeterminate);
    selectedMainRowData.forEach(item => {
        if (item.detailListLength) {
            item.detailList.forEach(v => {
                v.selected && taskNoList.push(v.taskNo);
            });
        }
    });
    return taskNoList;
};